
import { SiriusBaseComponent } from 'sirius-framework';
import { Component, Input, Output, EventEmitter, ViewChild, TemplateRef } from '@angular/core';
import { CommonService } from '../../shared/service/shared.service';
import { CancelProcessRequest, CancelProcessResponse, ProcessItem } from '../../shared/models/process.model';
import { FormGroup, Validators, FormControl } from '@angular/forms';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

@Component({ 
    selector: 'cancel-process',
    templateUrl: './cancel-process.component.html',
    styleUrls: ['./cancel-process.component.css']
})
export class CancelProcessComponent extends SiriusBaseComponent<any> {
    @Input('SelectedProcess') selectedProcess: ProcessItem;
    @Output('OnProcessCancel') onProcessCancel = new EventEmitter<void>();

    @ViewChild("cancelTemplate") cancelTemplate: TemplateRef<any>;

    pageIndex: number = 0;
    cancelReasonForm: FormGroup;
    resultMessage: string;
    result: boolean;

    modalRef: BsModalRef;

    /* String Resource */
    cancelProcess_Title: string;
    cancelProcess_Text: string;
    cancelProcess_Reason: string;
    cancelProcess_Warning: string;
    cancelProcess_Abandon: string;
    cancelProcess_Cancel: string;
    cancelProcess_Close: string;
    cancelProcess_ProcessType1: string;
    cancelProcess_ProcessType2: string;
    cancelProcess_Result1: string;
    cancelProcess_Result2: string;
    cancelProcess_StatusWarning: string;
    constructor(private commonService: CommonService,
      private modalService: BsModalService) {
        super();
    }
    OnInit() {    
        this.setStringResource();
        this.cancelReasonForm = new FormGroup({
            'cancelReason': new FormControl("", [Validators.required])
        }); 
    }
    setStringResource() {
        this.cancelProcess_Title = this.resourceService.getResource("cancelProcess_Title");
        this.cancelProcess_Reason = this.resourceService.getResource("cancelProcess_Reason");
        this.cancelProcess_Warning = this.resourceService.getResource("cancelProcess_Warning");
        this.cancelProcess_Abandon = this.resourceService.getResource("cancelProcess_Abandon");
        this.cancelProcess_Cancel = this.resourceService.getResource("cancelProcess_Cancel");
        this.cancelProcess_Close = this.resourceService.getResource("cancelProcess_Close");
        this.cancelProcess_ProcessType1 = this.resourceService.getResource("cancelProcess_ProcessType1");
        this.cancelProcess_ProcessType2 = this.resourceService.getResource("cancelProcess_ProcessType2");
        this.cancelProcess_Result1 = this.resourceService.getResource("cancelProcess_Result1");
        this.cancelProcess_Result2 = this.resourceService.getResource("cancelProcess_Result2");
        this.cancelProcess_StatusWarning = this.resourceService.getResource("cancelProcess_StatusWarning");
    }
    cancelProcess() {
        if (this.cancelReasonForm.valid) {
            var cancelProcessInfo: CancelProcessRequest = {
                FirmReference: this.selectedProcess.FirmReference,
                CancelReason: this.cancelReasonForm.controls.cancelReason.value,
            }
            var promise = this.commonService.CancelProcess(this.dataService, cancelProcessInfo);
            promise.then((result: CancelProcessResponse) => {
                this.pageIndex = 1;
                if (result == null || result.InfoMessageId == 0) {
                    this.result = false;
                    if (result.ErrorMessage != null && result.ErrorMessage != "") {
                        this.resultMessage = result.ErrorMessage;
                    }
                    else {
                        this.resultMessage = this.cancelProcess_Result1;
                    }
                }
                else {
                    this.resultMessage = this.cancelProcess_Result2;
                    this.result = true;
                    this.onProcessCancel.emit();
                }
            }, (error) => {
                this.pageIndex = 1;
                this.resultMessage = this.cancelProcess_Result1;
                this.result = false;
            });
        }
        else {
            this.cancelReasonForm.controls.cancelReason.markAsTouched();
        }  
    }
    showPopup() {
      this.initPopup();
      this.modalRef = this.modalService.show(this.cancelTemplate);
  }
  closePopup() {
    this.modalRef.hide();
  }
    initPopup() {      
        if (this.selectedProcess.ProcessStatus == "5") {
            this.pageIndex = 1;
            this.resultMessage = this.cancelProcess_StatusWarning;
            this.result = false;
        }
        else {
            this.pageIndex = 0;
            this.resultMessage = "";
            this.result = false;
            this.cancelReasonForm.reset();
            this.cancelProcess_Text = this.commonService.prepareStringText(this.resourceService.getResource("cancelProcess_Text"),
                [{ key: 'referenceId', value: this.selectedProcess.FirmReference, bold: true }]);
        }
    }
}
